import { contractAbis, multicall_address, multicall_abi } from '@/constants/abis'
import Web3 from 'web3';
import { contract as currentContract, infura_url } from '@/contract'

const getCalls = (poolId) => {
    const calls = [];

    let coinsN = contractAbis[poolId].N_COINS
    if (contractAbis[poolId].REAL_COINS)
      coinsN = contractAbis[poolId].REAL_COINS


    for (var i = 0; i < coinsN - 1; i++) {
        //price_oracle
        calls.push([contractAbis[poolId].swap_address, '0x68727653000000000000000000000000000000000000000000000000000000000000000'+i])
        //price_scale
        calls.push([contractAbis[poolId].swap_address, '0xa3f7cdd5000000000000000000000000000000000000000000000000000000000000000'+i])
    }

    //initial_A_gamma
    calls.push([contractAbis[poolId].swap_address, '0x204fe3d5'])
    //future_A_gamma
    calls.push([contractAbis[poolId].swap_address, '0xf30cfad5'])

    return calls;
};

const callCryptoPoolData = async (poolId) => {
    let web3 = currentContract.web3 || new Web3(infura_url)
    let multicall = new web3.eth.Contract(multicall_abi, multicall_address)

    const aggcalls = await multicall.methods.aggregate(getCalls(poolId)).call()
    return aggcalls[1].map((hex) => web3.eth.abi.decodeParameter('uint256', hex))
}

export default callCryptoPoolData;
